import 'reflect-metadata';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalConsumer, MsalProvider } from '@azure/msal-react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import dayjs from 'dayjs';
import dayjsBusinessDays from 'dayjs-business-days2';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import React, { type JSX } from 'react';
import { createRoot } from 'react-dom/client';
import 'simplebar/dist/simplebar.min.css';
import '@bixeng/rte/styles';
import App from './App';
import { NoAuthZeroDashSdkProvider, ZeroDashSdkProvider } from './contexts/ZeroDashSdkContext';
import './index.css';
import { LoadingPage } from './pages/Loading/Loading';
import reportWebVitals from './reportWebVitals';
import { zccTheme } from './themes/zccTheme';
import { msalConfig } from './utils/config/authConfig';

dayjs.extend(advancedFormat);
dayjs.extend(relativeTime);
dayjs.extend(dayjsBusinessDays);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);

  const disableAuth = import.meta.env.VITE_DISABLE_AUTH === 'true';

  root.render(
    <React.StrictMode>
      <CssBaseline />
      <ThemeProvider theme={zccTheme}>
        {disableAuth ? (
          <NoAuthZeroDashSdkProvider>
            <App />
          </NoAuthZeroDashSdkProvider>
        ) : (
          <MsalProvider instance={new PublicClientApplication(msalConfig)}>
            <MsalConsumer>
              {(val): JSX.Element => (
                val.inProgress === 'startup'
                  ? (
                    <LoadingPage />
                  ) : (
                    <ZeroDashSdkProvider>
                      <App />
                    </ZeroDashSdkProvider>
                  )
              )}
            </MsalConsumer>
          </MsalProvider>
        )}
      </ThemeProvider>
    </React.StrictMode>,
  );
}

// ReactDOM.render(
//   <React.StrictMode>
//     <CssBaseline />
//     <MsalProvider instance={msalInstance}>
//       <MsalConsumer>
//         {(val): JSX.Element => (
//           val.inProgress === 'startup'
//             ? (
//               <LoadingPage />
//             ) : (
//               <ZeroDashSdkProvider>
//                 <ThemeProvider theme={zccTheme}>
//                   <App />
//                 </ThemeProvider>
//               </ZeroDashSdkProvider>
//             )
//         )}
//       </MsalConsumer>
//     </MsalProvider>
//   </React.StrictMode>,
//   document.getElementById('root'),
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
